
import Menu from './Menu';
import MenuItem from './MenuItem';
import SubMenu from './SubMenu';
import Divider from './Divider';

Menu.SubMenu = SubMenu;
Menu.Item = MenuItem;
Menu.Divider = Divider;

export default Menu;
